<div
  class="eva-toggle-switch"
  [class.eva-toggle-switch--small]="size === 'small'"
  [class.eva-toggle-switch--medium]="size === 'medium'"
  [class.eva-toggle-switch--large]="size === 'large'"
  [class.eva-toggle-switch--disabled]="disabled"
  [class.eva-toggle-switch--focused]="isFocused"
  [class.eva-toggle-switch--icon-only]="isIconOnly"
  role="tablist"
  [attr.aria-label]="'Toggle switch'"
  [attr.aria-disabled]="disabled"
>
  <!-- Slider indicator (animated background, JS-positioned) -->
  <div
    class="eva-toggle-switch__slider"
    [class.eva-toggle-switch__slider--hidden]="selectedIndex < 0"
    [style.left.px]="sliderLeft"
    [style.width.px]="sliderWidth"
  ></div>

  <!-- Options -->
  <ng-container *ngFor="let option of options; let i = index; trackBy: trackByValue">
    <button
      #optionButton
      type="button"
      class="eva-toggle-switch__option"
      [class.eva-toggle-switch__option--selected]="isSelected(option)"
      [class.eva-toggle-switch__option--disabled]="isOptionDisabled(option)"
      [class.eva-toggle-switch__option--focused]="focusedIndex === i"
      [disabled]="isOptionDisabled(option)"
      [attr.aria-selected]="isSelected(option)"
      [attr.aria-disabled]="isOptionDisabled(option)"
      [attr.tabindex]="isSelected(option) ? 0 : -1"
      role="tab"
      [evaTooltip]="option.tooltip"
      evaTooltipPosition="top"
      (click)="selectOption(option, i)"
      (focus)="handleFocus(i)"
      (blur)="handleBlur()"
    >
      <!-- Icon -->
      <ng-icon *ngIf="option.icon && isHeroIcon(option.icon)" [name]="option.icon" class="eva-toggle-switch__icon" />
      <i *ngIf="option.icon && !isHeroIcon(option.icon)" [class]="option.icon" class="eva-toggle-switch__icon"></i>

      <!-- Label + sous-label -->
      <span *ngIf="option.label || option.subLabel" class="eva-toggle-switch__text">
        <span *ngIf="option.label" class="eva-toggle-switch__label">{{ option.label }}</span>
        <span
          *ngIf="option.subLabel"
          class="eva-toggle-switch__sublabel"
          [style.color]="option.subLabelColor || null"
          >{{ option.subLabel }}</span
        >
      </span>

      <!-- Badge counter -->
      <span
        *ngIf="showCount && option.count !== undefined && option.count !== null"
        class="eva-toggle-switch__badge"
        [class.eva-toggle-switch__badge--active]="isSelected(option)"
      >
        {{ option.count }}
      </span>
    </button>
  </ng-container>
</div>
